module.exports = __webpack_public_path__ + "static/img/dashuang.04f95ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/market/dashuang.png
// module id = JcpO
// module chunks = 2